import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthMethodViewModel, StaticCodeAuthMethodViewModel } from '../../../../services/identity';
import { MethodBase } from '../base/base.component';

@Component({
  selector: 'app-method-static-code',
  standalone: false,
  templateUrl: './static-code.component.html',
  styleUrl: './static-code.component.scss'
})
export class StaticCodeComponent extends MethodBase {
    private staticCodeMethod: StaticCodeAuthMethodViewModel

  constructor(
    private fb: FormBuilder
  ) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.setup();
    this.monitorFormStatus();
    
  }

  cancel(): StaticCodeAuthMethodViewModel {
    this.setup();
    return this.method;
  }

  override setup(): void {
    this.staticCodeMethod = this.method as StaticCodeAuthMethodViewModel;
    this.form = this.fb.group({
      code: [this.staticCodeMethod.code, [Validators.required, Validators.minLength(this.options.state.staticCode.minLength), Validators.pattern(this.options.validators.regStaticCodeOrPlaceholder)]]
    });
  }

  override getMethod(): AuthMethodViewModel {
    this.staticCodeMethod.code = this.form.value.code;
    return this.staticCodeMethod;
  }
}
